import { mockUserPrivilegesQuery } from '@sbu/hooks.privileges/build/mocks';

export const handlers = [
  mockUserPrivilegesQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        userPrivileges: [
          {
            key: 'CanSetAsDefaultDashboard',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CanDisplayAlertResponsePageListView' as any,
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CanDisplayMonitoringSLOListView',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'MetricsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'TraceAnalyticsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SpansAnalyticsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'ServiceMapAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SanaInformationModelsViewAccess' as any,
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'SanaInformationModelsManageAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'SanaParsersViewAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'SanaParsersManageAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'SanaLookupTablesAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'BillingAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'HealthEventsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'AWSUpgradeEligible',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'RequestUpgrade',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'RequestUpgradeButton',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'AWSSubscriptions',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'PaidTrial',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CollectorsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'IngestAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'ArchiveAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'AgentsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SourceTemplateAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CollectionDataForwardingAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'IngestCollectionsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'IndexesViewAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'ScheduledViewsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'ApiDocAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'ManageScheduledViewsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'PartitionsNewViewAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'PartitionsManageAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'ConnectionsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'AlertsConnectionsViewAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'ConnectionsViewAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'AuditLoggingView',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SearchAuditLoggingView',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'NewFERViewAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'NewFERManageAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SupportAccountView',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'PublicDashboardView',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'DataUsageLoggingViewAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'MultiRetentionAccountView',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'UseNewBatonTransactionStateMachine',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'NeedsActivation',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'CanChangeEmail',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'CanChangeOrgName',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CanDeleteOrg',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'CanChangeAccountSubdomain',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'UIPerIndexDataForwardingEnabled',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SLFApps',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'AWSApps',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'PreviewApps',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'UIDataForwardingFlagsEnabled',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SanaCsiemAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'DataAccessLevelView',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'ConcurrentSessionLimitView',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'UserSessionTimeoutView',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CseContentOptInView',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'LookupContentAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'FieldsViewAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'FieldsManageAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'MutingSchedulesAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'MutingSchedulesViewAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'MutingSchedulesManageAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'UnifiedMonitorsViewAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'UnifiedMonitorsManageAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'UnifiedMonitorsLockAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'UnifiedMonitorsAdminAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SlosViewAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SlosManageAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CSEAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'ParsersViewAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CanCreateAccessKeys',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'RootCauseExplorerAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarD1Access',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarD2Access',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'RequestUpgradeV2Access',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'EntityInventoryAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'MonitorsOarIntegrationAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarGeneralConfigure',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarCustomizationFields',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarCustomizationIncidentLabels',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarNotificationTriage',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarNotificationConfigure',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarUserManagementGroups',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarIncidentAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarIncidentTriageAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarEntitiesAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarReportAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarAppCentralAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarPlaybooksAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarIncidentTemplatesAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarIntegrationsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarAutomationRulesAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CloudSoarBridgeMonitoringAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemSearchAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemStatusAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SignalsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemEntitiesAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'RecordsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SecurityDetectionAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'RulesAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'RuleTuningAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemThreatIntelligenceAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'MatchListsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'FileAnalysisAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'CustomInsightsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'NetworkBlocksAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SuppressedListsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'MitreCoverageAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemIngestMappingsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemLogMappingsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemContextActions',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemActionsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemEnrichmentsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemAutomationAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemEntityGroupsAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemNormalizationAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemCustomEntityTypesAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemEntityCriticalityAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemInsightDetectionAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemInsightStatusAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemInsightResolutionAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SiemTagSchemasAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'AccountDataManagementAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'AccountBillingAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'ManagePaymentTabAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'AccountUpgradeAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'AccountOverviewAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'UsageManagementTabAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'AccountBetaParticipationAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'AccountNewUpgradeAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'ViewOrganizationsAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'CreateTrialOrganizationsAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'CreateOrganizationsAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'UpgradeTrialOrganizationsAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'ChangeCreditsAllocationAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'DeactivateOrganizationsAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'PasswordPolicyAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'WhitelistAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'AccessKeysAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'PoliciesAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'SAMLAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'InstallationTokensAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'MetricsRulesAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'DataForwardingAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'DataDeletionAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'ThreatIntelligenceAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'MetricsExtractionAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'MetricsDPMAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'FieldExtractionRulesAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'MetricsTransformationRulesAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'TrafficShapingAccess',
            value: false,
            __typename: 'Privilege',
          },
          {
            key: 'UsersTabAccess',
            value: true,
            __typename: 'Privilege',
          },
          {
            key: 'RolesTabAccess',
            value: true,
            __typename: 'Privilege',
          },
        ],
      })
    );
  }),
];
